import config from '@/config/index.js'
let { publicPath } = config
let urlObj = publicPath.test // 这里可以改本地调试的环境
const href = location.hostname
if (href.includes('dev')) {
  urlObj = publicPath.dev
}
if (href.includes('test')) {
  urlObj = publicPath.test
}
if (href.includes('pro')) {
  urlObj = publicPath.pro
}
if (href.includes('wssmall.g-part.cn')) {
  urlObj = publicPath.pro
}
if (href.includes('airplex.g-part.cn')) {
  urlObj = publicPath.pro
}
if (href.includes('uat')) {
  urlObj = publicPath.uat
}
if (href.includes('airplex.g-parts.cn')) {
  urlObj = publicPath.uat
}
export default urlObj
